var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-social-account custom-shadow",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"icon-container"},[_vm._v(" + ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }